import { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { GrClose } from "react-icons/gr";
import "../AppModal/ModalKit.css";

interface PropData {
  show: any;
  isClose: any;
  delete: any;
  data? : any;
  message? :any;
  button1? :any;
  button2? :any;
  variant? :any;   // 'archive' -> amber + archive icon; 'restore' -> green + restore icon; 'confirm' -> brand purple + question icon (plain are-you-sure prompts); default -> red delete
  title? :any;
}

const AlertModal = (props: PropData) => {
    const [open, setOpen] = useState(true)
    const cancelButtonRef = useRef(null)
    const isArchive = props.variant === 'archive';
    const isRestore = props.variant === 'restore';
    const isConfirm = props.variant === 'confirm';

  const handleClose = () => {
    props.isClose();
  };
  const OnDelete = () => {
    props.delete();
    props.isClose();
  };
  return (
    <div>
      {props.show &&
        <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-[1050]" initialFocus={cancelButtonRef} onClose={setOpen}>
            <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className="fixed inset-0 bg-[rgba(28,31,62,0.55)] transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-[1050] overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <Dialog.Panel className="fpm-panel fpm-sm">
                            <button type="button" className="fpm-x" title="Close" onClick={handleClose}>
                                <GrClose size={15} />
                            </button>
                            <div className="fpm-modal">
                                <div className="fpm-head">
                                    <div className={"fpm-badge " + (isConfirm ? "" : isRestore ? "fpm-badge-green" : isArchive ? "fpm-badge-amber" : "fpm-badge-red")}>
                                        {isConfirm ? (
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.7.4-1 .9-1 1.7" /><path d="M12 17h.01" /></svg>
                                        ) : isRestore ? (
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7" /><path d="M3 4v5h5" /></svg>
                                        ) : isArchive ? (
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="4" rx="1" /><path d="M5 8v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8" /><path d="M10 12h4" /></svg>
                                        ) : (
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><path d="M12 9v4" /><path d="M12 17h.01" /></svg>
                                        )}
                                    </div>
                                    <Dialog.Title as="h2">
                                        {props.title ? props.title : isConfirm ? 'Please confirm' : isRestore ? 'Confirm restore' : isArchive ? 'Confirm archive' : props.message ? 'Alert' : 'Confirm delete'}
                                    </Dialog.Title>
                                </div>
                                <p className="fpm-msg">
                                    {props.message ? props.message : isRestore ? 'Are you sure you want to restore?' : isArchive ? 'Are you sure you want to archive?' : 'Are you sure you want to delete?'}
                                </p>
                                <div className="fpm-foot">
                                    <button
                                        type="button"
                                        className="fpm-btn"
                                        onClick={handleClose}
                                        ref={cancelButtonRef}
                                    >
                                        {props.button2 ? props.button2 : 'Cancel'}
                                    </button>
                                    <button
                                        type="button"
                                        className={"fpm-btn-brand " + (isConfirm ? "" : isRestore ? "fpm-btn-green" : isArchive ? "fpm-btn-amber" : "fpm-btn-red")}
                                        onClick={OnDelete}
                                    >
                                        {props.button1 ? props.button1 : isConfirm ? 'Confirm' : isRestore ? 'Restore' : isArchive ? 'Archive' : props.message ? 'OK' : 'Delete'}
                                    </button>
                                </div>
                            </div>
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </div>
        </Dialog>
    </Transition.Root>
      }
    </div>
  );
};

export default AlertModal;
